export default {"src":"/_next/static/media/reward_40.b5efb02d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};